<template>
  <div :class="{'overflow-hidden': isShowingSideMenuOverAll}">

    <b-badge v-if="badgeEnv" class="badge-env" variant="danger"> {{ badgeEnv }}</b-badge>

    <div id="app" :class="{ 'background-create-annonce': isActiveRoute(lighterBackgroundRoutes)}">

      <!-- Pages without sidebar and navbar -->
      <div v-if="hideNavigation">
        <div>
          <transition mode="out-in" name="fade">
            <router-view></router-view>
          </transition>
        </div>
      </div>

      <!-- Pages with sidebar and navbar -->
      <div v-else>
        <div class="row no-gutters">
          <!-- sidebar : grand public version: un menu par-dessus à ouvrir si en dessous de lg -->
          <b-collapse v-if="!isDesktopNavigation" id="sidebar-mobile" class="part-sidebar col-12 darker-theme">
            <div id="sidebar">
              <div class="d-flex justify-content-end sidebar-mobile-close-container">
                <div v-b-toggle.sidebar-mobile class="ml-auto mobile-menu-icon">
                  <i class="ph-custom ph-x sidebar-mobile-close-icon"/>
                </div>
              </div>

              <b-nav vertical>
                <SideMenu
                  :key="sideMenuKey"
                  :links="sidebarLinksAndDesktopMenuLinks"
                  :windowHeight="windowHeight"
                  @clickAction="sideMenuClickAction"
                >
                </SideMenu>
              </b-nav>

            </div>
          </b-collapse>

          <!-- navbar -->
          <div :class="{ 'background-create-annonce': isActiveRoute(lighterBackgroundRoutes)}"
               class="col-12 main-color-background">
            <b-navbar :class="{'no-sticky-navbar-for-md-annonce-create': isActiveRoute(['/annonce/create']) }"
                      class="navbar-hover-body d-block sticky-navbar"
                      toggleable="md">

              <!-- navbar: top part (flex) -->
              <div class="navbar p-0 justify-content-start">
                <!-- Left aligned: brand-icon -->
                <b-navbar-brand>
                  <div>
                    <img :class="{'navbar-icon-clickable': !isActiveRoute(['/'])}"
                         :src="require(`@/assets/images/b122/ic_lamp_logo.png`)"
                         alt="Logo" class="navbar-icon" @click="goToHome">
                  </div>
                </b-navbar-brand>

                <!-- Left aligned: filters btn (if accueil & annonces index) -->
                <div v-if="displayFilters" :class="{'navbar-desktop-left-part': isDesktopNavigation}"
                     class="mr-1 d-flex align-items-center">

                  <!-- recherche barre -->
                  <div v-if="isDesktopNavigation" id="searchbar-desktop" :class="{'show': !isSearchCollapsed }"
                       class="mr-1 b-collapse-horizontal collapse">
                    <div id="searchbar-desktop-inside" class="d-flex w-100">
                      <SearchBarForm
                        id="searchbarform-desktop"
                        :isDesktop=true
                        :searchInitial=search
                        @didUpdateSearchText="didUpdateSearchText"
                        @didValidateSearchText="didValidateSearchText">
                      </SearchBarForm>
                    </div>
                  </div>

                  <!-- recherche toggle btn -->
                  <b-button ref="navbarSearchBtnOpenClose"
                            v-b-toggle.searchbar-mobile
                            :class="{'': !isSearchCollapsed}"
                            class="mr-1 d-flex btn-icon-navbar btn-icon-navbar-more-centered navbar-search-ele-must-be-clicked"
                            variant="navbar-primary"
                            @click="toggleSearchCollapse">
                    <i
                      :class="{'ph-magnifying-glass': isSearchCollapsed, 'ph-caret-left': !isSearchCollapsed && isDesktopNavigation, 'ph-caret-up': !isSearchCollapsed && !isDesktopNavigation}"
                      class="ph-custom align-self-center navbar-search-ele-must-be-clicked"/>
                  </b-button>

                  <!-- simple filtres -->
                  <template v-if="isDesktopNavigation && isSearchCollapsedFollowingCollapsed">
                    <b-button :variant="isSelectedFilterLocation ? 'navbar-secondary-inversed' : 'navbar-secondary'"
                              class="mr-1 d-flex navbar-button-filters-modal"
                              @click="goToSearch('localisation')">
                      <i class="ph-custom ph-map-pin align-self-center"/>
                      <div>{{ $t('Filters.localisation') }}</div>
                    </b-button>
                    <b-button
                      :variant="nbSelectedFilterVehicleType > 0 ? 'navbar-secondary-inversed' : 'navbar-secondary'"
                      class="mr-1 navbar-button-filters-modal"
                      @click="goToSearch('vehicles')">
                      <div>{{ selectedVehicleTypeText ? selectedVehicleTypeText : $t('Filters.vehicles') }}</div>
                    </b-button>
                    <b-button :variant="nbSelectedFilterBrand > 0 ? 'navbar-secondary-inversed' : 'navbar-secondary'"
                              class="mr-1 navbar-button-filters-modal"
                              @click="goToSearch('brands')">
                      <div>{{ selectedBrandText ? selectedBrandText : $t('Filters.brands') }}</div>
                    </b-button>
                  </template>

                  <!-- all filtres -->
                  <b-button
                    :class="{'btn-icon-navbar btn-icon-navbar-more-centered-more-width mr-2': !isDesktopNavigation}"
                    :variant="(isDesktopNavigation && (isSelectedOneFilterExceptLocation || (!isSearchCollapsedFollowingCollapsed && isSelectedOneFilter))) || (!isDesktopNavigation && isSelectedOneFilter) ? 'navbar-secondary-inversed' : 'navbar-secondary'"
                    class="mr-1 d-flex navbar-button-filters-modal"
                    @click="goToSearch('filters')">
                    <i class="ph-custom ph-faders align-self-center"/>
                    <div v-if="isDesktopNavigation">{{ $t('Filters.filters') }}</div>
                  </b-button>

                </div>

                <!-- Right aligned: desktop menus dropdown / notifs pop up -->
                <div v-if="isDesktopNavigation" class="ml-auto d-flex navbar-desktop-right-part">

                  <!-- create Annonce -->
                  <b-button v-if="displayAnnonceCreateBtn" class="mr-3" variant="navbar-primary"
                            @click="goToAnnonceCreate">
                    <div>{{ $t('Menu.create.annonce') }}</div>
                  </b-button>

                  <!-- account icon + Menu desktop -->
                  <b-collapse id="accountIconAndMenuDesktop" is-nav>
                    <b-navbar-nav>
                      <b-nav-item-dropdown class="dropdown-custom dropdown-my-account-custom" right>

                        <!-- Using 'button-content' slot -->
                        <template #button-content>
                          <div class="d-flex desktop-menu-icon-user">
                            <div class="mr-2_5">{{ userNames }}</div>
                            <i class="ph-custom ph-user-circle align-self-center"/>
                          </div>
                        </template>

                        <!-- items -->
                        <template v-for="linkData in sidebarLinksAndDesktopMenuLinks">
                          <div v-if="linkData.isInDesktopMenu && linkData.hasTopSep" class="dropdown-sep-custom"></div>

                          <b-dropdown-item v-if="linkData.isInDesktopMenu"
                                           :class="linkData.customClassDesktop"
                                           :disabled="isActiveRoute(linkData.routesActiveItem)"
                                           @click="linkData.onClickAction">
                            <div :class="{'activeItem': isActiveRoute(linkData.routesActiveItem)}" class="d-flex">
                              <i :class="linkData.icon" class="ph-custom align-self-center mr-2"/>
                              <div>{{ linkData.title }}</div>
                            </div>
                          </b-dropdown-item>
                        </template>

                      </b-nav-item-dropdown>
                    </b-navbar-nav>
                  </b-collapse>

                  <!-- notif icon + Notif Pop up -->
                  <b-collapse id="notifIconAndNotifMenu" is-nav>
                    <b-navbar-nav>
                      <b-nav-item-dropdown class="ml-2 dropdown-custom dropdown-notifs-custom" right
                                           @hide="updateNotifications"
                                           @bv::dropdown::show="onDropdownShow">

                        <!-- Using 'button-content' slot -->
                        <template #button-content>
                          <div class="desktop-menu-icon align-self-center desktop-menu-icon-bell">
                            <i class="ph-custom ph-bell align-self-center"/>
                          </div>
                        </template>

                        <!-- one item ! -->
                        <b-dropdown-item @click.stop="preventDropdownClose">
                          <NotifsMenu
                            ref="notifsMenu"
                            :windowHeight="windowHeight">
                          </NotifsMenu>
                        </b-dropdown-item>

                      </b-nav-item-dropdown>
                    </b-navbar-nav>
                  </b-collapse>

                </div>
                <!-- Right aligned: 2 mobile-menu-icon -->
                <div v-else class="ml-auto d-flex">
                  <!-- account icon + toggle Menu mobile -->
                  <div v-b-toggle.sidebar-mobile class="mobile-menu-icon ml-2 mobile-menu-icon-user">
                    <i class="ph-custom ph-user-circle align-self-center"/>
                  </div>
                  <!-- notif icon + open sidebar-notif -->
                  <div v-b-toggle.sidebar-mobile-notifs class="mobile-menu-icon ml-3 mobile-menu-icon-bell pr-3">
                    <i class="ph-custom ph-bell align-self-center"/>
                  </div>
                </div>
              </div>

              <!-- navbar: bottom part -->
              <b-collapse v-if="!isDesktopNavigation" id="searchbar-mobile">
                <div class="navbar-searchbar-mobile">

                  <SearchBarForm
                    id="searchbarform-mobile"
                    :searchInitial=search
                    @didUpdateSearchText="didUpdateSearchText"
                    @didValidateSearchText="didValidateSearchText">
                  </SearchBarForm>

                </div>
              </b-collapse>
            </b-navbar>

            <div class="page-container">
              <transition mode="out-in" name="fade">
                <router-view></router-view>
              </transition>
              <div v-if="!isActiveRoute(['/annonce/create','/annonce/edit'])" class="main-footer">
                <p>Copyright &#169; 2023 {{ $t('TitleProjectUC') }}.
                  <span style="white-space: nowrap;">All rights reserved.</span>
                </p>
                <p style="white-space: nowrap;">Made with
                  <heart-icon class="" style="color: var(--main-yellow-medium)"/>
                  by <a class="footer-bleu122-link" href="https://www.bleu122.com/">Bleu122</a></p>
              </div>
            </div>

          </div>

          <!-- sidebar num 2 : notifs pour le grand public: un menu par-dessus à ouvrir SI en dessous de lg -->
          <b-collapse v-if="!isDesktopNavigation" id="sidebar-mobile-notifs" class="part-sidebar col-12 darker-theme"
                      @hide="updateNotifications">
            <div id="sidebar-notifs">
              <div class="d-flex justify-content-end sidebar-mobile-close-container">
                <div v-b-toggle.sidebar-mobile-notifs class="ml-auto mobile-menu-icon">
                  <i class="ph-custom ph-x sidebar-mobile-close-icon"/>
                </div>
              </div>

              <NotifsMenu
                ref="notifsMenu"
                :is-mobile=true
                :windowHeight="windowHeight">
              </NotifsMenu>
            </div>
          </b-collapse>


        </div>
      </div>

      <first-connexion-modal ref="firstConnexionModal" :isFirstConnexion="isFirstConnexion"></first-connexion-modal>
      <identity-to-validate-modal></identity-to-validate-modal>
      <support-modal></support-modal>
      <show-bug-report-modal></show-bug-report-modal>
      <ScanMenu></ScanMenu>


    </div>
  </div>
</template>

<script>

import SideMenu from './views/menus/SideMenu'
import NotifsMenu from './views/menus/NotifsMenu'
import SearchBarForm from './views/menus/SearchBarForm'
import FirstConnexionModal from "./views/user/FirstConnexionModal"
import IdentityToValidateModal from "./views/user/IdentityToValidateModal.vue";
import SupportModal from "./views/user/SupportModal.vue";
import ScanMenu from "./views/match/ScanMenu";
import api from "./services/api"
import {eventBus} from "./main"
import ShowBugReportModal from "./components/b122/ShowBugReportModal";

export default {

  metaInfo: {
    title: 'LAMP App - Retrouvez votre véhicule volé',
    meta: [
      {
        name: 'description',
        content: 'Grâce à la communauté LAMP, retrouvez votre véhicule volé, et soyez récompensé en devenant enquêteur...'
      }
    ]
  },

  name: 'App',

  components: {
    SideMenu,
    NotifsMenu,
    SearchBarForm,
    FirstConnexionModal,
    IdentityToValidateModal,
    SupportModal,
    ScanMenu,
    ShowBugReportModal
  },

  data() {
    return {
      badgeEnv: null,
      isFirstConnexion: null,
      identityRefused: null,
      sideMenuKey: 0,
      userNames: null,
      windowHeight: window.innerHeight,
      displayAnnonceCreateBtn: true,
      displayFilters: false,
      search: null,
      searchValidated: null,
      isSearchCollapsed: true,
      isSearchCollapsedFollowingCollapsed: true,
      isDesktopNavigation: this.checkIsDesktop(),

      isShowingSideMenuOverAll: false,

      filtersData: null,

      isSelectedFilterLocation: false,
      nbSelectedFilterVehicleType: 0,
      selectedFilterVehicleTypeNameIfOne: null,
      nbSelectedFilterBrand: 0,
      selectedFilterBrandNameIfOne: null,
      isSelectedOneFilter: false,
      isSelectedOneFilterExceptLocation: false,

      lighterBackgroundRoutes: [
        '/annonce/create', '/annonce/edit'
      ],

      sidebarLinksAndDesktopMenuLinks: [
        {
          'icon': null,
          'title': this.$i18n.t('Menu.create.annonce'),
          'route': '/annonce/create',
          'routesActiveItem': ['/annonce/create'],
          'isLogout': false,
          'isRed': false,
          'isMainButton': true,
          'customClass': '',

          'isInDesktopMenu': false,
          'onClickAction': null,
          'hasTopSep': null,
          'customClassDesktop': null,
        },
        {
          'icon': 'ph-user-circle',
          'title': this.$i18n.t('Menu.my.account'),
          'route': '/user/profileShow',
          'routesActiveItem': ['/user/profileShow'],
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.goToProfile,
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-flashlight',
          'title': this.$i18n.t('Menu.check.match'),
          'route': '/',
          'routesActiveItem': [],
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.showScanMenuModal,
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-megaphone',
          'title': this.$i18n.t('Menu.my.alerts'),
          'route': '/user/MyAlerts', //todo menu url
          'routesActiveItem': [], //todo menu url
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.goToAlerts, //todo menu url
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-heart',
          'title': this.$i18n.t('Menu.my.favorites'),
          'route': '/', //todo menu url
          'routesActiveItem': [], //todo menu url
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.goToFavorites,
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-gear',
          'title': this.$i18n.t('Menu.autorisations'),
          'route': '/autorisations',
          'routesActiveItem': ['/autorisations'],
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.goToAutorisation,
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-wallet',
          'title': this.$i18n.t('Menu.payment'),
          'route': '/',
          'routesActiveItem': [],
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': 'd-none',

          'isInDesktopMenu': true,
          'onClickAction': this.goToPayment,
          'hasTopSep': false,
          'customClassDesktop': 'd-none',
        },
        {
          'icon': 'ph-question',
          'title': this.$i18n.t('Menu.support'),
          'route': '/', //todo menu url
          'routesActiveItem': [], //todo menu url
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.showSupportModal, //todo menu url
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-bug',
          'title': this.$i18n.t('Menu.report'),
          'route': '/', //todo menu url
          'routesActiveItem': [], //todo menu url
          'isLogout': false,
          'isRed': false,
          'isMainButton': false,
          'customClass': '',

          'isInDesktopMenu': true,
          'onClickAction': this.showReportBugModal, //todo menu url
          'hasTopSep': false,
          'customClassDesktop': '',
        },
        {
          'icon': 'ph-x-circle',
          'title': this.$i18n.t('Menu.logout'),
          'route': null,
          'routesActiveItem': null,
          'isLogout': true,
          'isRed': true,
          'isMainButton': false,
          'customClass': 'pt-60',

          'isInDesktopMenu': true,
          'onClickAction': this.logout,
          'hasTopSep': true,
          'customClassDesktop': 'desktop-menu-logout-item dropdown-item-red',
        }
      ],
    }
  },

  computed: {


    hideNavigation() {
      return !this.$store.getters.isAuthenticated
    },

    selectedVehicleTypeText() {
      if (this.nbSelectedFilterVehicleType === 0) {
        return null
      }
      if (this.selectedFilterVehicleTypeNameIfOne) {
        return this.selectedFilterVehicleTypeNameIfOne
      }
      return this.nbSelectedFilterVehicleType + ' ' + this.$i18n.t('vehicles')
    },

    selectedBrandText() {
      if (this.nbSelectedFilterBrand === 0) {
        return null
      }
      if (this.selectedFilterBrandNameIfOne) {
        return this.selectedFilterBrandNameIfOne
      }
      return this.nbSelectedFilterBrand + ' ' + this.$i18n.t('brands')
    },

    isActiveRoute() {
      let domaineActive = this.$route.path.split('/')[1]
      let actionActive = this.$route.path.split('/')[2]
      return routesActiveItem => routesActiveItem ? routesActiveItem.filter(routeActiveItem => {
        let domaineRoute = routeActiveItem.split('/')[1]
        let actionRoute = routeActiveItem.split('/')[2]
        return domaineRoute === domaineActive && actionActive === actionRoute
      }).length > 0 : false
    },

  },

  created() {
    eventBus.$on('updateFiltersValues', this.updateFiltersValues)
    eventBus.$on('resetFiltersValues', this.resetFiltersValues)
    eventBus.$on('initElseResetFiltersValues', this.initElseResetFiltersValues)
    eventBus.$on('closedFiltersModal', this.resetFocusButtons)
    eventBus.$on('showBugReportModal', () => {
      this.showReportBugModal()
    });
    const userProperties = [
      'username',
      'roles',
      'isAdmin',
    ]
    const userForSentry = {};
    userProperties.forEach(key => {
      userForSentry[key] = this.$store.getters[key];
    });
    Sentry.setUser(userForSentry)
  },

  destroyed() {
    eventBus.$off('updateFiltersValues', this.updateFiltersValues)
    eventBus.$off('resetFiltersValues', this.resetFiltersValues)
    eventBus.$off('initElseResetFiltersValues', this.initElseResetFiltersValues)
    eventBus.$off('closedFiltersModal', this.resetFocusButtons)
    eventBus.$off('showBugReportModal', () => {
      this.showReportBugModal()
    });
  },

  mounted() {
    if (localStorage.locale != null) {
      this.$i18n.locale = localStorage.locale
    }
    this.refreshRoutesAccess()
    this.fetchUserData()
    this.fetchHomeData()

    window.addEventListener('resize', this.handleResize)
    window.addEventListener('focus', this.handleWindowFocus)
    this.$root.$on('bv::collapse::state', this.refreshCollapsedProperties)

    this.fetchEnvironment()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {

    '$store.getters.username': function (newValue, oldValue) {
      this.fetchUserData()
      this.fetchHomeData()
    },

    '$route.path': function (newValue, oldValue) {
      this.refreshRoutesAccess()
    },

  },

  methods: {

    onDropdownShow(evt) {
      evt.preventDefault();
    },
    preventDropdownClose(evt) {
      evt.stopPropagation();
    },


    showReportBugModal() {
      this.$bvModal.show('show-bug-report-modal');
    },
    async fetchEnvironment() {
      const response = await api.get('/home/getEnvironmentName');
      let badgeStr = null
      if (response.data.toString() !== 'production') {
        badgeStr = response.data.toString().length > 7 ? response.data.toString().substring(0, 3).toUpperCase() : response.data.toString().toUpperCase()
      }
      this.badgeEnv = badgeStr
    },

    checkIsDesktop() {
      return window.innerWidth >= 768;
    },

    handleResize() {
      this.isDesktopNavigation = this.checkIsDesktop();
    },

    /** appelé sur tous les changements onShow onHide des b-collapse */
    refreshCollapsedProperties(collapseId, isJustShown) {
      // console.log('collapseId:', collapseId)
      // console.log('isJustShown:', isJustShown)

      var isANavbarElementCollapse = collapseId === "accountIconAndMenuDesktop" || collapseId === "notifIconAndNotifMenu"
      var isASideMenuCollapse = collapseId === "sidebar-mobile" || collapseId === "sidebar-mobile-notifs"

      if ((isANavbarElementCollapse || isASideMenuCollapse) && !isJustShown) {
        this.isShowingSideMenuOverAll = false
      }
      if (isASideMenuCollapse && isJustShown) {
        this.isShowingSideMenuOverAll = true
      }
    },

    async logout() {
      await this.$store.dispatch('LogOut')
      await this.$router.push('/login')
    },

    fetchHomeData() {
      if (this.$store.getters.isAuthenticated) {
        api
          .get(`/home/getHomeInfos`)
          .then(response => {
            this.isFirstConnexion = response.data.isFirstConnexion
            this.identityRefused = response.data.identityRefused
            if (this.isFirstConnexion) {
              this.showOnBoardingModal()
            }
            if (this.identityRefused) {
              this.showIdentityValidationModal()
            }
            this.$refs.firstConnexionModal.fetchUserIdentityValidation()
          })
      }
    },

    handleWindowFocus() {
      this.fetchHomeData()
    },

    updateNotifications() {
      this.$refs.notifsMenu.updateNotifications()
    },

    fetchUserData() {
      if (this.$store.getters.isAuthenticated) {
        api
          .get(`/user/currentUserData`)
          .then(response => {
            this.userNames = response.data.userNames
            this.$store.state.currentUserCountryCode = response.data.countryCode
            if (response.data.stripeCustomerId !== null) {
              let wallet = this.sidebarLinksAndDesktopMenuLinks.filter((link) => link.icon === 'ph-wallet')
              wallet[0].customClass = ''
              wallet[0].customClassDesktop = ''
            }
          })
      }
    },

    toggleSearchCollapse(event) {
      if (event !== 'isFromFakeJsClick' && (!event || ![...event.srcElement.classList].includes('navbar-search-ele-must-be-clicked'))) {
        //l'event ne provient pas réellement du bouton jaune => il vient de la barre de recherche qui s'est repliée et qui est cachée par le bouton jaune
        //dans le cas de isFromFakeJsClick: on veut quand même appliquer toggleSearchCollapse !
        return
      }

      this.isSearchCollapsed = !this.isSearchCollapsed

      if (!this.isSearchCollapsed) {
        this.followingToggleSearchCollapse()
      } else {
        if (this.search !== null) {
          this.search = null

          if (this.isActiveRoute(['/search'])) {
            eventBus.$emit("resetSearchInputWithUpdateResults")
          } else {
            eventBus.$emit("resetSearchInput")
          }
        }

        if (this.searchValidated !== null) {
          this.searchValidated = null
        }

        //pour que les boutons de filtres simples s'affichent apres et pas avant la fermeture de la search bar
        setTimeout(() => {
          this.followingToggleSearchCollapse()
        }, 400)
      }
    },

    followingToggleSearchCollapse() {
      this.isSearchCollapsedFollowingCollapsed = this.isSearchCollapsed
      eventBus.$emit("updateIsSearchCollapsedFollowingCollapsed", this.isSearchCollapsedFollowingCollapsed)

      if (!this.isSearchCollapsed) {
        eventBus.$emit("focusSearchInput")
      } else if (this.$refs.navbarSearchBtnOpenClose) {
        this.$refs.navbarSearchBtnOpenClose.blur()
      }
    },

    refreshRoutesAccess() {
      this.displayAnnonceCreateBtn = !this.isActiveRoute(['/annonce/create', '/annonce/edit'])
      this.displayFilters = this.isActiveRoute(['/', '/search'])
    },

    didUpdateSearchText(newSearchText) {
      if (newSearchText && newSearchText !== "" && newSearchText.trim() !== "") {
        this.search = newSearchText
      } else {
        this.search = null
      }
    },

    didValidateSearchText(newSearchText) {
      if (newSearchText && newSearchText !== "" && newSearchText.trim() !== "") {
        this.search = newSearchText
        this.searchValidated = newSearchText
      } else {
        this.search = null
        this.searchValidated = null
      }
    },

    updateFiltersValues(filtersData) {
      this.filtersData = filtersData

      this.isSelectedFilterLocation = filtersData.locationRadius && filtersData.latitude && filtersData.longitude
      this.nbSelectedFilterVehicleType = JSON.parse(filtersData.vehicles).length
      this.selectedFilterVehicleTypeNameIfOne = filtersData.selectedFilterVehicleTypeNameIfOne
      this.nbSelectedFilterBrand = JSON.parse(filtersData.brands).length
      this.selectedFilterBrandNameIfOne = filtersData.selectedFilterBrandNameIfOne

      this.isSelectedOneFilterExceptLocation = JSON.parse(filtersData.vehicles).length > 0 || JSON.parse(filtersData.brands).length > 0 || JSON.parse(filtersData.models).length > 0 || JSON.parse(filtersData.modelFinishes).length > 0 || JSON.parse(filtersData.colors).length > 0 || JSON.parse(filtersData.energies).length > 0 || filtersData.isSelectedFiscalPowerFilter

      this.isSelectedOneFilter = this.isSelectedOneFilterExceptLocation || this.isSelectedFilterLocation
    },

    /** quand on fait un retour avec flèche du navigateur par exemple, et que les filtersData sont encore dans App.vue */
    initElseResetFiltersValues() {
      if (!this.searchValidated) {
        this.search = null
        eventBus.$emit("resetSearchInput")
      } else {
        this.search = this.searchValidated
        eventBus.$emit("refreshSearchInput", this.searchValidated)
      }

      if (this.filtersData || this.searchValidated) {
        if (this.searchValidated) {
          if (this.filtersData) {
            eventBus.$emit("getSearchInputFromApp", this.searchValidated)
          } else {
            eventBus.$emit("getSearchInputFromAppWithUpdateResults", this.searchValidated)
          }
        }

        if (this.filtersData) {
          eventBus.$emit("initFiltersDataInFiltersModal", this.filtersData)
        }

      } else {
        this.resetFiltersValues(false)
        //seul cas où il ne faut pas reset la valeur du search text
        // => car initElseResetFiltersValues peut être appelé à l'arrivée sur Search.vue par la recherche par text depuis Home.vue
        // dans ce cas il est intéressant de reset les filtres par précaution, mais il faut garder la recherche

        eventBus.$emit("searchWithoutFiltersData")
      }
    },

    /** TODO penser à placer ce reset à chaque fois qu'on part de la page de recherche, sauf dans le show (ou l'edit ?) d'une annonce */
    resetFiltersValues(withResetOfSearch = true) {
      if (withResetOfSearch) {
        this.search = null
        this.searchValidated = null
        eventBus.$emit("resetSearchInput")
      }

      this.filtersData = null

      this.isSelectedFilterLocation = false
      this.nbSelectedFilterVehicleType = 0
      this.selectedFilterVehicleTypeNameIfOne = null
      this.nbSelectedFilterBrand = 0
      this.selectedFilterBrandNameIfOne = null
      this.isSelectedOneFilterExceptLocation = false
      this.isSelectedOneFilter = false

      //+ close searchbar if open
      if (withResetOfSearch && !this.isSearchCollapsed) {
        // pour faire comme si this.$refs.navbarSearchBtnOpenClose.click() sauf que ca fonctionne même si navbarSearchBtnOpenClose n'est plus disponible (déjà caché)
        this.toggleSearchCollapse('isFromFakeJsClick')
        this.$root.$emit('bv::toggle::collapse', 'searchbar-mobile')
      }
    },

    resetFocusButtons() {
      this.$el.querySelectorAll('.navbar-button-filters-modal').forEach((element) => {
        element.blur()
      })
    },


    //--------------- ROUTES -----------------

    sideMenuClickAction(event) {
      //Pour éxécuter le onClickAction des éléments dans le composant SideMenu
      event()
    },

    goToHome() {
      this.resetFiltersValues()
      if (this.isActiveRoute(['/'])) {
        return
      }
      this.$router.push({
        name: 'Home'
      })
    },

    goToSearch(fromBtnName) {
      //chercher uniquement depuis les pages home ou search
      if (!this.isActiveRoute(['/', '/search'])) {
        return
      }
      if (!['localisation', 'brands', 'vehicles', 'filters'].includes(fromBtnName)) {
        return
      }

      var isAlreadyInSearch = this.isActiveRoute(['/search'])

      if (isAlreadyInSearch) {
        eventBus.$emit("openFiltersModal", fromBtnName)
      } else {
        this.$router.push({
          name: 'Search',
          params: {
            fromBtnName: fromBtnName,
            filtersData: this.filtersData,
          }
        })
      }
    },

    goToProfile() {
      this.resetFiltersValues()
      this.$router.push({
        name: 'ProfileShow'
      })
    },


    goToAlerts() {
      this.resetFiltersValues()
      this.$router.push('/user/MyAlerts')
    },

    goToFavorites() {
      this.resetFiltersValues()
      this.$router.push({
        name: 'MyFavorites'
      })
    },

    goToAutorisation() {
      this.resetFiltersValues()
      this.$router.push({
        name: 'Autorisations'
      })
    },

    goToPayment() {
      api({
        method: 'POST',
        url: `/user/manageStripeProfile`,
      })
        .then((response) => {
          window.open(response.data.url, '_blank');
        })
        .catch((error) => {
          this.successToast(this.$i18n.t('stripe.error'))
        })
    },

    goToReport() {
      this.resetFiltersValues()
      this.$router.push('/report')
    },

    goToAnnonceCreate() {
      this.resetFiltersValues()
      this.$router.push({
        name: 'AnnonceCreate'
      })
    },

    //region modals
    showScanMenuModal() {
      this.$bvModal.show("scan-menu-modal")
    },

    showOnBoardingModal() {
      this.$bvModal.show('first-connexion-modal')
    },

    showIdentityValidationModal() {
      this.$bvModal.show('identity-to-validate-modal')
    },

    showSupportModal() {
      this.$bvModal.show("support-modal")
    },
    //endregion

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        solid: true,
        headerClass: 'toast-header-custom',
        bodyClass: 'toast-body-custom',
      })
    },

  }

}
</script>

<style scoped>
.badge-env {
  padding: 8px;
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 10;
  font-size: 14px;
  background-color: var(--main-red-medium);
}

.pt-60 {
  padding-top: 60px;
}

.sidebar-mobile-close-container {
  padding-top: 20px;
  padding-right: 20px;
}

.sidebar-mobile-close-icon {
  font-size: 32px;
}

.main-color-background {
  background-color: var(--main-black-darker);
}

.part-sidebar {
  position: fixed;
  z-index: 10;
}

#sidebar, #sidebar-notifs {
  position: relative;
  height: 100%;
  min-height: 100vh;
  padding-top: 20px;
  top: 0;
  z-index: 2;
  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.15);
}

.sidebar-list {
  margin-top: 2em;
}

.main-footer {
  position: absolute;
  bottom: 0;
  width: 96%;
  height: 3rem;
  display: flex;
  justify-content: space-between;
  margin: 0 2%;
  padding-top: 10px;
  border-top: 1px solid #D0CFCF;
  z-index:0;
}

.page-container {
  position: relative;
  min-height: 89vh;
  padding-bottom: 3rem;

  /* important car courbure du bas de la navbar par-dessus la page-container quand la map est affichée par exemple */
  margin-top: -20px;
  padding-top: 20px; /* pour rééquilibrer */
}

/* ----- marges sur droite et gauche en desktop (lg) / moins en mobile ----- */
.navbar {
  padding: 0.1rem 1rem;
}

.page-container {
  margin-left: 1rem !important;
  margin-right: 1rem !important;
}

@media (min-width: 768px) {
  .navbar {
    padding: 0.1rem 4rem;
  }

  .page-container {
    margin-left: 4rem !important;
    margin-right: 4rem !important;
  }
}

/* ------------------------------------------------------------------------- */

.content-wrap {
  padding-bottom: 3rem; /* Footer height */
}

.desktop-menu-icon {
  border: none;
  display: flex;
}

.mobile-menu-icon {
  color: var(--main-white);
  border: none;

  display: flex;
}

.mobile-menu-icon:hover {
  color: var(--main-yellow-medium)
}

.mobile-menu-icon-bell {
  padding-top: 1px;
  cursor: pointer;
}

.mobile-menu-icon-user i {
  font-size: 32px;
}

.mobile-menu-icon-bell i {
  font-size: 28px;
}

.desktop-menu-icon-bell i {
  font-size: 24px;
}

.desktop-menu-icon-user i {
  font-size: 24px;
}

@media only screen and (max-width: 991px) and (min-width: 768px) {
  .main-footer {
    width: 96%;
    height: 3.5rem;
  }

  .content-wrap {
    padding-bottom: 3.5rem; /* Footer height */
  }
}

@media only screen and (max-width: 767px) {
  .sidebar-header-logo {
    width: 100px;
  }

  .main-footer {
    width: 96%;
    font-size: 12px;
    height: 3.5rem;
  }

  .content-wrap {
    padding-bottom: 3.5rem; /* Footer height */
  }

  .page-container {
    min-height: 82vh;
  }
}

.desktop-menu-logout-item {
  color: var(--main-red-medium);
}

/* Onglet actif dans desktop menu */
.activeItem {
  color: var(--main-yellow-medium);
}

/* searchbar */
.navbar-searchbar-mobile {
  margin-top: 10px;
  margin-bottom: 10px;
}

/* Styles pour l'animation horizontale => obligé d'utiliser ça, les 'b-collapse' ne permettent que du vertical ! */
#searchbar-desktop {
  background-color: var(--main-black-dark);
  margin-left: 10px;
}

/* pour que le surlignage autour de l'input soit visible au focus, meme si overflow: hidden; */
#searchbar-desktop-inside {
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 4px;
}

.b-collapse-horizontal {
  display: flex !important; /** important sinon une propriété css passe par-dessus en environnement de preprod/intégration/prod */
  flex-direction: row-reverse;
  margin-left: auto;
  overflow: hidden;
  transition: width 0.5s ease-out;
  -webkit-transition: width 0.5s ease-out;
  -moz-transition: width 0.5s ease-out;

  width: 0;
}

#searchbar-desktop.b-collapse-horizontal.show {
  width: 100%;
}

.background-create-annonce {
  background-color: var(--main-black-dark) !important;
}

#app {
  height: 100vh;
}

.navbar-desktop-left-part {
  height: 60px;
}

.navbar-desktop-right-part {
  height: auto;
  align-items: end;
  margin-top: auto;
  margin-bottom: 15px;
}


</style>



// WEBPACK FOOTER //
// src/App.vue